var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Ip_phone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ip_phone",
    clipPath: "url(#clip-Ip_phone)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone_System_active",
    transform: "translate(-19.003 -18.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone_System",
    "data-name": "Phone System",
    transform: "translate(21.003 22.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M20808.773,13762.524h-12.941a.759.759,0,0,1-.621-.323.07.07,0,0,0-.02-.019v-.012a.771.771,0,0,1-.123-.42v-15.032a.762.762,0,0,1,.221-.546.747.747,0,0,1,.543-.224h12.947a.779.779,0,0,1,.619.316v.016l.006,0h0v.006h0v0h0a.747.747,0,0,1,.119.422v15.032a.767.767,0,0,1-.754.773Zm-4.437-5.172h0v2.063h2.1v-2.062Zm-3.092,0h0v2.063h2.074v-2.062Zm-3.08,0h0v2.063h2.07v-2.062Zm6.17-3.119h0v2.066h2.1v-2.088Zm-3.092,0h0v2.066h2.074v-2.088Zm-3.078,0h0v2.066h2.068v-2.088Zm6.168-3.123h0v2.068h2.1v-2.068Zm-3.09,0h0v2.068h2.074v-2.068Zm-3.082,0h0v2.068h2.07v-2.068Z",
    transform: "translate(-20789.523 -13745.912)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Op_component_2",
    "data-name": "Op component 2",
    d: "M411.714,1124.6H412.8a.929.929,0,0,0,.614-.224.728.728,0,0,0,.254-.545h0V1108.7a.7.7,0,0,0-.138-.411s-.008-.011-.011-.015a.068.068,0,0,0-.015-.019.9.9,0,0,0-.7-.321h-2.932a.822.822,0,0,0-.866.769v15.124h0a.7.7,0,0,0,.138.417.053.053,0,0,1,.01.013c.005.009.012.013.015.02a.9.9,0,0,0,.7.32H411.7",
    transform: "translate(-409.006 -1107.934)",
    fill: "#2e78d5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpPhoneIcon);
export default __webpack_public_path__ + "static/media/Ip_Phone_icon.3f904e8f967a9d4af16659e3faf9d27c.svg";
export { ForwardRef as ReactComponent };